import { Question } from '../models/value_meter_question'

const buildQuestionIndex = (questions: Record<string, Question>): Record<string, Question> => {
  const index: Record<string, Question> = {}

  const visit = (qs: Record<string, Question>) => {
    for (const [key, q] of Object.entries(qs)) {
      index[q.name] = q
      if (q.subQuestions) visit(q.subQuestions)
    }
  }

  visit(questions)

  return index
}

export const buildFormSubmissionPayload = (data: Record<string, unknown>, questions: Record<string, Question>): Record<string, unknown> => {
  const formSubmissionPayload: Record<string, unknown> = {}
  const questionIndex = buildQuestionIndex(questions)

  for (const key of Object.keys(data)) {
    // Find the question to determine the data type
    const question = questionIndex[key]

    if (!question) {
      formSubmissionPayload[key] = data[key]
      continue
    }

    if (question.isDisplayOnly === 'true') {
      // Skip display-only questions
      continue
    }

    switch (question.dataType) {
    case 'int':
      formSubmissionPayload[question.name] = parseInt(data[key] as string, 10)
      break
    case 'float':
      formSubmissionPayload[question.name] = parseFloat((data[key] as string).replace(',', '.'))
      break
    case 'boolean':
      formSubmissionPayload[question.name] = `${data[key]}`.toLowerCase() === 'true'
      break
    case 'string':
    default:
      formSubmissionPayload[question.name] = data[key]
    }
  }

  return formSubmissionPayload
}
